var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ruler.design == 'V' )?_c('vertical-ruler',{attrs:{"ruler":_vm.ruler}}):_vm._e(),(_vm.ruler.design == 'H' )?_c('horizontal-ruler',{attrs:{"ruler":_vm.ruler}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }